/* eslint-disable react/no-unescaped-entities */
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

/** PremiumStatus context — single fetch, shared across the whole app.
 *  Exposes { comingSoon, ready, waitlistCount, refresh }.
 */
const PremiumStatusCtx = createContext({ comingSoon: false, ready: false, waitlistCount: 0, refresh: () => {} });

export function PremiumStatusProvider({ children }) {
  const [state, setState] = useState({ comingSoon: false, ready: false, waitlistCount: 0 });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/premium/status");
      setState({
        comingSoon: !!data.coming_soon,
        ready: true,
        waitlistCount: data.waitlist_count || 0,
      });
    } catch {
      // Network/backend hiccup — assume coming-soon mode is OFF (do not silently block legitimate flows).
      setState({ comingSoon: false, ready: true, waitlistCount: 0 });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <PremiumStatusCtx.Provider value={{ ...state, refresh }}>{children}</PremiumStatusCtx.Provider>
  );
}

export function usePremiumStatus() {
  return useContext(PremiumStatusCtx);
}
